module.exports = __webpack_public_path__ + "asset/img/sad_turtle.44c7c1b1758e2f1bdcbe32e90f339c03.png";